import {useState} from 'react';
import Layout, {Titolo} from '../Layout';
import {apiDownload, handleApiError} from '../api';
import {dataCompatta} from '../utils';

export default function AmministrazionePage() {
    const [dal, setDal] = useState('');
    const [al, setAl] = useState('');

    function scaricaZipOrdini(event) {
        event.preventDefault();
        const from = dataCompatta(dal);
        const to = dataCompatta(al);
        apiDownload('/ordini-as-pass/csv', {from, to}, `NVDM_CsvOrdini_${from}_${to}.zip`)
            .catch(handleApiError);
    }

    return (
        <Layout>
            <Titolo indietro>Amministrazione</Titolo>
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">Download CSV ordini da AS400</h5>
                    <p className="text-secondary">Ordini di Treviso e Sanremo (ex Websmart), in un file zip con i CSV per Passepartout.</p>
                    <form className="row g-3 align-items-end" onSubmit={scaricaZipOrdini}>
                        <div className="col-auto">
                            <label className="form-label" htmlFor="dal">Dal</label>
                            <input id="dal" type="date" className="form-control" value={dal}
                                   onChange={(e) => setDal(e.target.value)} required/>
                        </div>
                        <div className="col-auto">
                            <label className="form-label" htmlFor="al">Al</label>
                            <input id="al" type="date" className="form-control" value={al}
                                   onChange={(e) => setAl(e.target.value)} required/>
                        </div>
                        <div className="col-auto">
                            <button type="submit" className="btn btn-primary">
                                <i className="bi-download me-2"></i>Scarica
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </Layout>
    );
}
